export default {
    state: {
        data: {

        }
    },
    mutations: {
        ['favourite/setState'](state, payload) {
            state.data = {...payload,}
        },
    },
    actions: {
        async ['favourite/addToFavorite']({ state: { data }, commit }, payload) {
            try{
                const { path, ['params-example-data']: { action } } = data.routes.add;
                const response = await axios.post(path, {
                    action,
                    id: payload,
                })

                if (response.status === 200) {
                    console.log(response.data)
                    commit('favourite/setState', response.data);
                }
            } catch( err ) {
                console.error(err)
            }
        },
        async ['favourite/deleteFromFavorite'] ({ state: { data }, commit}, payload) {
            try{

                const { id, groupId } = payload
                const { path, ['params-example-data']: { action } } = data.routes.remove;
                console.log({
                    action,
                    id: id,
                    groupId: groupId,
                });

                    const response = await axios.post(path, {
                        action,
                        id: id,
                        groupId: groupId,
                    })
                if (response.status === 200) {
                    commit('favourite/setState', response.data)
                }
            } catch (err) {
                console.error(err)
            }
        },
        async ['favourite/addGroupToFavorite']({ state: { data }, commit }, payload) {
            try{
                const { path } = data.routes.addGroup;
                const response = await axios.post(path, payload);
                if (response.status === 200) {
                    commit('favourite/setState', response.data)
                }
            } catch( err ) {
                console.error(err);
            }
        },
        async ['favourite/editFavoriteGroup'] ({ state: { data }, commit }, payload) {
            try{
                const { path } = data.routes.changeGroup;
                const response = await axios.post(path, payload);
                if (response.status === 200) {
                    commit('favourite/setState', response.data)
                }
            } catch(err) {
                console.error(err);
            }
        },
        async ['favourite/deleteFavoriteGroup'] ({ state: { data }, commit }, payload) {
            try{
                const { path, ['params-example-data']: { action } } = data.routes.removeGroup;
                payload.append('action', action);
                const response = await axios.post(path, payload);
                if (response.status === 200) {
                    commit('favourite/setState', response.data)
                }
            } catch(err) {
                console.error(err);
            }
        },
        async ['favourite/moveItemInFavoriteGroup'] ({ state: { data }, commit }, payload) {
            try{
                const { path } = data.routes.moveLikes;
                const response = await axios.post(path, payload);
                if (response.status === 200) {
                    commit('favourite/setState', response.data)
                }
            } catch(err) {
                console.error(err);
            }
        }
    },
    getters: {
        ['favourite/checkElementInFavorite']: state => payload => {
            try {
                // const items = state?.data?.idItems;
                const groups = state?.data?.group;
                const group = groups?.find( el => el.base === 'Y');
                return !!group?.items?.find(el => {
                    const id = el.offer && el.offer.id || el.id;
                    return id == payload;
                });
            } catch (err) {
                console.log(err)
            }
        }
    }
}